import React, { useEffect, useState } from "react";
import "./cancellation.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

function Cancellation({ token }) {
  const navigate = useNavigate();

  const [cancelling, setCancelling] = useState(true);
  const { reservation_secret } = useParams();
  const [message, setMessage] = useState("Processing your request...");
  const [subText, setSubText] = useState("");

  const cancelBooking = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/bookings/${reservation_secret}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status !== 200) {
        setMessage(
          "An error occurred while cancelling your booking. Please try again later.",
        );
        return;
      }

      setMessage(response.data.split(" || ")[0]);
      setSubText(response.data.split(" || ")[1] || "");
    } catch (error) {
      setMessage(
        "An error occurred while cancelling your booking. Please try again later.",
      );
    } finally {
      setCancelling(false);
    }
  };

  useEffect(() => {
    if (!reservation_secret) {
      navigate("/");
    } else if (token) {
      cancelBooking();
    }
  }, [reservation_secret, navigate, token]);

  return (
    <div className="cancellation-page">
      <div className="cancellation-nav">
        <div className="cancellation-logo">
          <img alt="Hymus Sports Logo" className="cancellation-logo-img" src={logo} />
        </div>
      </div>

      <div className="cancellation-container">
        <img className="cancellation-img" src={logo} alt="Hymus Sports Logo" />
        <h2 className="cancellation-title">{message}</h2>
        <p className="cancellation-txt">{subText}</p>
        {!cancelling ? (
          <div className="cancellation-btn">
            <a href="/">RETURN HOME</a>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Cancellation;
